import React from 'react';
import PropTypes from 'prop-types';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';

DashboardChartCard.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  valueColor: PropTypes.string,
  actionEl: PropTypes.element,
  chartEl: PropTypes.element,
  titleAccessory: PropTypes.node,
  additionalInfo: PropTypes.string,
};

function DashboardChartCard(props) {
  // MARK: ---- PROPERTIES ----
  const { title, name, value, valueColor, actionEl, chartEl, titleAccessory, additionalInfo } = props;

  return (
    <div>
      {UIHelper.buildCard(
        <div className="px-4 py-4">
          {/* header */}
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <span className="font-weight-bolder d-flex gap-2 align-items-center"
                style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                {title}
                {titleAccessory}
                {additionalInfo?.text?.length ? (
                  <KTTooltip
                    text={additionalInfo?.text}
                    textHeader={additionalInfo?.header}
                    isHtmlContent
                  >
                    <i className="fa-regular fa-info-circle" style={{ color: AppColors.primary }} />
                  </KTTooltip>
                ) : <></>}
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                {name}:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', valueColor)}>{value}</span>
              </span>
            </div>
            <div>{actionEl}</div>
          </div>

          {/* chart */}
          <div className="h-300px mt-2">{chartEl}</div>
        </div>,
        false
      )}
    </div>
  );
}

export default DashboardChartCard;
